import { StaticImage } from '../../../../utils/image';
import './subCard.scss';
import TagDuoTone from "../../../iconComponent/TagDuoTone";
import { checkComplete, checkLeftTime, checkLeftTimeIcon, checkLeftTimeStatus } from '../../../../utils';
import { ConvertDateShort } from '../../../../utils/date';
import { useHistory } from 'react-router-dom';
import { encodeBase64 } from '../../../../utils/convertBase64';
import ProgressBar from './../../progressBar';
import { useEffect } from 'react';
const isKeyboardActivation = (event) => event.key === 'Enter' || event.key === ' ';

const SurveyCardSubItem = ({ survey, project }) => {
    const history = useHistory();
    const renderPublishNo = () => {
        return (
            <div className="d-flex-align-center" style={{ marginRight: 20 }}>
                <img
                    src={StaticImage("/images/icon/pen-nib-duotone.svg")}
                    style={{ marginRight: 5 }}
                    height={16}
                    alt="public-no"
                />
                <div className="d-flex" style={{ alignItems: 'center' }}>
                    <span>ครั้งที่</span>
                    <div className="badge-public">{survey.publish_no}</div>
                </div>
            </div>
        );
    };
    const renderDate = () => {
        return (
            <div className="d-flex-align-center" style={{ marginRight: 20 }}>
                <img
                    src={StaticImage(checkLeftTimeIcon(survey) ? "/images/icon/vote-yea-duotone.svg" : "/images/icon/vote-nay-duotone.svg")}
                    style={{ marginRight: 5 }}
                    height={16}
                    alt="public-no"
                />
                <div className="d-flex" style={{ alignItems: 'center' }}>
                    <span>
                        {`${ConvertDateShort(survey.start_date, "DD MMM YY")} - ${ConvertDateShort(survey.end_date, "DD MMM YY")}`}
                    </span>
                </div>
            </div>
        );
    };
    const renderStatus = () => {
        return (
            checkLeftTimeStatus(survey)
        );
    };

    const navigate = (survey_id) => {
        history.push(`/listeningDetail?survey_id=${encodeBase64(survey_id)}`);
    }

    useEffect(() => {
        console.log("survey.state_agency_id::", survey.state_agency_id);
    }, []);

    const handleKeyDown = (event) => {
        if (isKeyboardActivation(event)) {
            event.preventDefault();
            navigate(survey.survey_id);
        }
    };

    return <div
        className="survey-sub-card-container"
        role="button"
        tabIndex={0}
        aria-label={`ดูรายละเอียดการรับฟัง ${survey.short_project_name ?? survey.project_name}`}
        onClick={() => navigate(survey.survey_id)}
        onKeyDown={handleKeyDown}
    >
        <div className="d-flex items-center">
            <span className="title text-primary text-regular flex-1">{survey.short_project_name ?? survey.project_name}</span>
            {survey.remark_warning && <div className="relative group">
                {/* Icon Warning */}
                <span className="text-yellow-500 text-2xl cursor-pointer">
                    ⚠️
                </span>

                {/* Tooltip : show on hover */}

                <div className="absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10 left-1/2 -translate-x-1/2 mt-1">
                    {survey.remark_warning}
                </div>
            </div>
            }
        </div>
        <div className="d-flex-align-center flex-1 bottom-position" >

            <div className="d-flex-align-center survey-type-container">
                <TagDuoTone />
                <span>
                    {survey.survey_type_name}
                </span>
            </div>
            {renderPublishNo()}
            <div className="d-flex-align-center flex-1 bottom-position">
                {checkLeftTimeIcon(survey) ? <>
                    <img
                        src={StaticImage(checkLeftTimeIcon(survey) ? "/images/icon/vote-yea-duotone.svg" : "/images/icon/vote-nay-duotone.svg")}
                        style={{ marginRight: 5 }}
                        height={14}
                        alt="public-no"
                    />
                    <span style={{ fontSize: 12 }}>
                        {ConvertDateShort(survey.start_date, "DD MMM YY")}
                    </span>
                    <section
                        className="progress-list-filter"
                        style={{ width: "100%", maxWidth: 300 }}
                    >
                        <ProgressBar
                            bgcolor={survey.date_balance > 7 ? "#387436" : "#f96b57"}
                            bgContainerColor={
                                survey.date_balance > 7 ? "#717377" : "#717377"
                            }
                            leftTime={checkLeftTime(survey)}
                            completed={checkComplete(survey)}
                        />
                    </section>
                    <span>
                        <span style={{ fontSize: 12 }}>
                            {ConvertDateShort(survey.end_date, "DD MMM YY")}
                        </span>
                    </span>
                    {survey.created_agency_id == 403 &&
                        <div className='flex ml-4 gap-x-2 items-center px-4 text-[#756039] bg-[#F7F1DE] rounded-xl'>
                            <img
                                src={StaticImage("/images/icon_v3/yellow/building-columns-duotone.svg")}
                                width={16}
                                height={16}
                                alt="webboard"
                            />
                            <span>สคก. สร้างการรับฟัง</span>
                        </div>
                    }
                </>
                    :
                    <>
                        {renderDate()}
                        {renderStatus()}
                        {survey.created_agency_id == 403 &&
                            <div className='flex ml-4 gap-x-2 items-center px-4 text-[#756039] bg-[#F7F1DE] rounded-xl'>
                                <img
                                    src={StaticImage("/images/icon_v3/yellow/building-columns-duotone.svg")}
                                    width={16}
                                    height={16}
                                    alt="webboard"
                                />
                                <span>สคก. สร้างการรับฟัง</span>
                            </div>
                        }
                    </>
                }
            </div>

        </div>
    </div>
}

export default SurveyCardSubItem;
